import Vue from 'vue'
import Vuex from 'vuex';
Vue.use(Vuex);



//mutations start
const mutations = {
  changeActiveMenuIndex(state, data) {
    state.activeMenuIndex = data;
  },
  authed(state, data) {
    state.authed = data;
  },
  matchCodeChange(state, data){
    state.matchCodeMsg= data;
  },
  matchInfoChange(state,data){
    state.matchInfoMsg= data;
  }
}



//state start
const state = {
  activeMenuIndex: 0,
  authed: false,
  matchCodeMsg:'',
  matchInfoMsg:{}
}

export default new Vuex.Store({
  state,
  mutations
});



// WEBPACK FOOTER //
// ./src/store/store.js